import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';
import { Header } from 'datastake-daf/dist/components';
import AssessmentAmp from './assessmentAmp';
import Style from '../../../../../../Analysis/style';
import FormCompletion from '../../widgets/form-completion';
import ApplicationStatus from '../../widgets/application-status';
import LayoutStyle from '../../../../../../Analysis/layouts/style';

export default function AmpDashborad() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authentication);

  const isAssessment = ['assessment', 'preAssessed', 'review'].includes(user?.amp?.status);

  if (isAssessment) {
    return <AssessmentAmp />;
  }

  return (
    <Style>
      <Header
        title={t('Dashboard Title')}
        supportText={t("Overview of your organisation's activity and information.")}
        actionButtons={[
          {
            icon: <DownloadOutlined />,
            onClick: () => { },
            disabled: true,
          }
        ]}
      />

      <div className="content">
        <div className="view-content">
          <LayoutStyle>
            <div className='sections-cont w-pt'>
              <section>
                <FormCompletion />
                <ApplicationStatus />
              </section>
            </div>
          </LayoutStyle>
        </div>
      </div>
    </Style>
  )
}
